import { render, staticRenderFns } from "./VacationCategoryEditComponent.vue?vue&type=template&id=b05699f0"
import script from "./VacationCategoryEditComponent.vue?vue&type=script&lang=js"
export * from "./VacationCategoryEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports